// ViewingRoomMode — the global light/dark presentation of the "viewing room".
// Replaces the plain 'light' | 'dark' string union.
export enum ViewingRoomMode {
    Light = 'LIGHT',
    Dark = 'DARK',
}
